import { QueryConstants } from '../../../../general/js/utils/query-constants';

export const apiConstants = {
    ACCESS_TOKEN_COOKIE_NAME: window.appState.ssoConfig.cookieStorage.accessTokenCookieName,
    loadDefaultRegisterFormDataUrl: '/api/sitecore/SSOFormContent/GetSSODefaultRegisterFormData',
    loadOneClubRegisterFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOOneClubRegisterFormData',
    loadTicketingRegisterFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOTicketingRegisterFormData',
    loadSSOItemListFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOItemListFormData',
    loadSignInFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOSignInFormData',
    loadNewPasswordRequiredFormDataUrl: '/api/sitecore/SSOFormContent/GetSSONewPasswordRequiredFormData',
    loadForgotPasswordFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOForgotPasswordFormData',
    loadResetPasswordFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOResetPasswordFormData',
    loadVerifyEmailFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOVerifyEmailFormData',
    emailAttributeName: 'email',
    verifyEmailFormDataUrl: `/?${QueryConstants.SHOW_POPUP}=api/sitecore/Account/SSOVerifyEmail`,
    loadFullBallotRegisterFormDataUrl: '/api/sitecore/SSOBallot/CognitoBallotFullRegisterJson',
    loadLiteBallotRegisterFormDataUrl: '/api/sitecore/SSOBallot/CognitoBallotLiteRegisterJson',
    ballotSummaryFormDataUrl: `?${QueryConstants.SHOW_POPUP}=api/sitecore/SSOBallot/CognitoBallotSummaryForm`,
    ballotSignInSuccessFormDataUrl: `?${QueryConstants.SHOW_POPUP}=api/sitecore/SSOBallot/BallotSignInSuccessForm`,
    signInSuccessFromDataUrl: '/api/sitecore/Account/SSOSignInSuccess',
    loadSSOUpgradeToOneClubFormDataUrl: '/api/sitecore/SSOFormContent/GetSSOUpgradeToOneClubFormData',
};
